<template>
  <div class="bussiness-behavior">
    <div class="header-tool">
      <div class="header-tool-info">
        <Breadcrumb>
          <BreadcrumbItem to="/exhibition/index">推广</BreadcrumbItem>
          <BreadcrumbItem to="/exhibition/index/business">商机</BreadcrumbItem>
          <BreadcrumbItem>行为轨迹</BreadcrumbItem>
        </Breadcrumb>
        <div class="header-tool-title">行为轨迹</div>
      </div>
      <div class="header-tool-box">
        <div class="htb-item" @click="$router.push('/exhibition/index/business')">
          <span>返回</span>
        </div>
      </div>
    </div>
    
    <div class="content-t">
      <img src="https://huizhanren.oss-cn-shanghai.aliyuncs.com/cloudExhibition/imgs/201910/c6da5fbaa77a43fbbc4952ccb30aab93.jpg">
      <div class="content-t-info">
        <p>姓名<span>职务</span></p>
        <p>公司公司公司公司公司公司公司公司公司公司公司公司公司</p>
        <p>手机号码</p>
      </div>
      <div class="content-t-icon">
        <Tooltip content="标记用户" placement="right">
          <i class="icon iconfont icon-shoucang"></i>
          <!-- <i class="icon iconfont icon-shoucang2"></i> -->
        </Tooltip>
      </div>
      <div class="content-t-data">
        <div>
          <p>浏览主页</p>
          <p>168次</p>
        </div>
        <div>
          <p>浏览产品</p>
          <p>168次</p>
        </div>
        <div>
          <p>咨询客服</p>
          <p>168次</p>
        </div>
        <div style="margin:0">
          <p>留言记录</p>
          <p>168条</p>
        </div>
      </div>
    </div>

    <div class="content-b">
      <div class="content-b-header">
        <p style="font-size:16px;color:#262626;">行为轨迹</p>
        <p>刷新</p>
      </div>
      <div class="content-b-footer">
        <p>2019/10/28 16:45:56</p>
        <p style="margin-left:20px;">对藿香正气水进行了评论对藿香正气水进行了评论对藿香正气水进行了评论对藿香正气水进行了评论对藿香正气水进行了评论对藿香正气水进行了评论对藿香正气水进行了评论对藿香正气水进行了评论对藿香正气水进行了评论</p>
      </div>
      <div class="content-b-footer">
        <p>2019/10/28 16:45:56</p>
        <p style="margin-left:20px;">对藿香正气水进行了评论对藿香正气水进行了评论对藿香正气水进行了评论对藿香正气水进行了评论对藿香正气水进行了评论对藿香正气水进行了评论对藿香正气水进行了评论对藿香正气水进行了评论对藿香正气水进行了评论</p>
      </div>
      <div class="content-b-footer">
        <p>2019/10/28 16:45:56</p>
        <p style="margin-left:20px;">对藿香正气水进行了评论对藿香正气水进行了评论对藿香正气水进行了评论对藿香正气水进行了评论对藿香正气水进行了评论对藿香正气水进行了评论对藿香正气水进行了评论对藿香正气水进行了评论对藿香正气水进行了评论</p>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "exhibition-business-behavior",
}
</script>

<style lang="scss" scoped>
.content-t {
  margin: 30px;
  min-width: 1000px;
  min-height: 150px;
  background-color: #fff;
  display: flex;
  align-items: center;
  position: relative;
  img {
    width: 90px;
    height: 90px;
    border-radius: 50%;
    margin-left: 50px;
  }
  &-info {
    margin-left: 30px;
    p {
      max-width: 400px;
      margin: 10px 0;
      span {
        margin:0 10px;
      }
    }
  }
  &-icon {
    margin: 0 0 60px 0;
    i {
      font-size: 26px;
      color: #1890ff;
      cursor: pointer;
    }
  }
  &-data {
    display: flex;
    position: absolute;
    right: 3%;
    div {
      margin-right: 35px;
      p {
        text-align: center;
      }
      p:first-child {
        color: #8c8c8c;
      }
      p:last-child {
        font-size: 26px;
        color: #262626;
        font-weight: bold;
      }
    }
  }
}
.content-b {
  margin: 30px;
  min-width: 1000px;
  min-height: 500px;
  background-color: #fff;
  &-header {
    display: flex;
    justify-content: space-between;
    border-bottom: 1px solid #e8e8e8;
    padding: 15px 30px;
    p:last-child {
      color: #8c8c8c;
      cursor: pointer;
    }
  }
  &-footer {
    padding: 10px 50px;
    border-bottom: 1px solid #e8e8e8;
    display: flex;
    p:first-child {
      white-space:nowrap;
    }
  }
}
</style>